import { ProcessingWorkOrders } from '../types/interfaces';

export const ProcessingWorkOrdersTemplate: ProcessingWorkOrders = {
  id: '',
  key: '',
  description: '',
  businessProcessName: '',
  taskStatuses: [
    {
      id: '',
      actionName: '',
      statusBefore: null,
      statusAfter: null,
      roles: [],
      priority: null,
      fieldFilling: []
    }
  ]
};
